import {
  INCOMEIQUEUE_RCM_ACTION_OPTIONS,
  INCOMEIQUEUE_RCM_SCENARIOS
} from 'lib/constants/healthcareProgram/incomeIQueueRcm';

import IncomeIQueueStepRow from './IncomeIQueueStepRow';

const IncomeIQueueStepSection = ({ networkType, values, onChange }) => {
  const handleScenarioChange = (field, nextValue) => {
    onChange({ ...values, [field]: nextValue });
  };

  return (
    <div className="flex flex-col gap-2">
      {INCOMEIQUEUE_RCM_SCENARIOS.map((scenario) => (
        <IncomeIQueueStepRow
          key={scenario.field}
          label={scenario.label}
          value={values?.[scenario.field]}
          options={INCOMEIQUEUE_RCM_ACTION_OPTIONS[scenario.field] || []}
          onChange={(next) => handleScenarioChange(scenario.field, next)}
          dataQa={`incomeiqueue-rcm-${networkType}-${scenario.field}`}
        />
      ))}
    </div>
  );
};

export default IncomeIQueueStepSection;
